import path from "./urlPath";
import r from "./request";

const get = r.get
const post = r.post
const postFile = r.postFile


export default {
   path,
   get,
   post,
   postFile
}